module.exports = __webpack_public_path__ + "static/how-to-use-3-a7c1fda370f03814a01a776cd4fe2834.png";